// src/slices/chatSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_QUERYURL } from '../components/constants';

// New thunk for fetching chat history
export const fetchChatHistory = createAsyncThunk(
  'chat/fetchChatHistory',
  async ({ historyId, userId, taskId }) => {
    // If taskId is empty string, use null for chat-only histories
    const realTaskId = (taskId === '' || taskId === undefined) ? null : taskId;
    const response = await fetch(`${BASE_QUERYURL}/question-history?history_id=${historyId}&user_id=${userId}&task_id=${realTaskId}`);
    const data = await response.json();
    console.log(data, 'data, res')
    return data.qa_pairs;
  }
);

export const sendChatMessage = createAsyncThunk(
  'chat/sendChatMessage',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_QUERYURL}/question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const error = await response.text();
        return rejectWithValue(error);
      }
      const data = await response.json();
      return data.response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    chatHistory: [],
    loading: false,
    error: null,
  },
  reducers: {
    addUserMessage: (state, action) => {

      console.log(action, 'action.payload user')
      state.chatHistory.push({ 
      
        role: 'user', 
        content: action.payload.content, 
        title: action.payload.title || ''
      });
    },
    addBotMessage: (state, action) => {
      if (!action.payload || !action.payload.id) {
        console.warn('addBotMessage: Invalid payload', action.payload);
        return;
      }
      state.chatHistory.push({ 
        id: action.payload.id,
        role: 'bot', 
        content: action.payload.content, 
        title: action.payload.title || ''
      });
    },
    clearChatHistory: (state) => {
      state.chatHistory = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchChatHistory.fulfilled, (state, action) => {
        // Always set loading to false, even if no messages
        state.loading = false;
        if (action.payload && action.payload.length > 0) {
          state.chatHistory = action.payload.map(qa => ({
            role: qa.role,
            content: qa.content,
            title: qa.title || '',
            comment: qa.comment || '',
            sources: qa.sources || [],
            id: qa.id
          }));
        } else {
          state.chatHistory = [];
        }
      })
      .addCase(fetchChatHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(sendChatMessage.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendChatMessage.fulfilled, (state, action) => {
        if (!action.payload || !action.payload.id) {
          console.warn('sendChatMessage.fulfilled: Invalid payload', action.payload);
          state.loading = false;
          return;
        }
        state.chatHistory.push({ 
          id: action.payload.id,
          role: 'bot', 
          content: action.payload.content,
          title: action.meta?.arg?.title || '',
          sources: action.payload.source || []
        });
        state.loading = false;
      })
      .addCase(sendChatMessage.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { addUserMessage, addBotMessage, clearChatHistory } = chatSlice.actions;
export default chatSlice.reducer;